module.exports = __webpack_public_path__ + "img/TLF.59347ec8.jpg";